import { MembershipInfo, InvitationInfo, MigrationInfo } from 'features/user_info'

import { UserGroupInfo } from './user_group_info'

export const MenuItemInfo = ({ suggestion, showUserRole }) => {
  switch (suggestion.type) {
    case 'organization_membership':
      return <MembershipInfo membership={suggestion.entity} showUserRole={showUserRole} isAvatarNonInteractive />
    case 'organization_invitation':
      return <InvitationInfo invitation={suggestion.entity} isAvatarNonInteractive />
    case 'user_group':
      return <UserGroupInfo userGroup={suggestion.entity} />
    case 'user_consolidation':
      return <MigrationInfo migration={suggestion.entity} isAvatarNonInteractive />
    default:
      return null
  }
}
